export const EMOJI_CATEGORIES = [
  {
    id: "smileys",
    label: "Smileys",
    keywords: ["smile", "happy", "sad", "face", "laugh", "cry"],
    emojis: [
      "😀", "😃", "😄", "😁", "😅", "😂", "🤣", "😊", "😇", "🙂",
      "😉", "😌", "😍", "🥰", "😘", "😋", "😎", "🤩", "🥳", "😏",
      "🤔", "🤗", "🤭", "😮", "😯", "😲", "😢", "😭", "😤", "😡",
    ],
  },
  {
    id: "gestures",
    label: "Gestures",
    keywords: ["hand", "thumb", "clap", "wave", "yes", "no", "star"],
    emojis: [
      "👍", "👎", "👏", "🙌", "🤝", "🙏", "💪", "✌️", "🤞", "👋",
      "👀", "💯", "✅", "❌", "⭐", "🌟", "💡", "🔥", "💥", "🎉",
    ],
  },
  {
    id: "work",
    label: "Work",
    keywords: ["job", "office", "computer", "email", "business", "career"],
    emojis: [
      "💼", "📋", "📊", "📈", "💻", "🖥️", "📱", "📧", "📝", "📅",
      "🏢", "🏠", "🚀", "🎯", "🏆", "🎓", "📚", "🔧", "⚙️", "🔑",
    ],
  },
  {
    id: "nature",
    label: "Nature",
    keywords: ["sun", "moon", "flower", "animal", "tree", "ocean"],
    emojis: [
      "🌞", "🌙", "⭐", "🌈", "🌸", "🌺", "🌻", "🌴", "🍀", "🌍",
      "🐶", "🐱", "🐻", "🦊", "🐼", "🦁", "🐸", "🦋", "🐝", "🌊",
    ],
  },
  {
    id: "food",
    label: "Food",
    keywords: ["eat", "drink", "coffee", "pizza", "burger", "cake"],
    emojis: [
      "☕", "🍕", "🍔", "🍟", "🌮", "🍣", "🍩", "🎂", "🍎", "🥗",
      "🍷", "🍺", "🧃", "🥤", "🍪", "🍫", "🧁", "🥑", "🍳", "🥐",
    ],
  },
  {
    id: "flags",
    label: "Flags",
    keywords: ["flag", "country", "nation", "usa", "uk", "india"],
    emojis: [
      "🇺🇸", "🇬🇧", "🇨🇦", "🇦🇺", "🇮🇳", "🇩🇪", "🇫🇷", "🇪🇸", "🇮🇹", "🇯🇵",
      "🇨🇳", "🇰🇷", "🇧🇷", "🇲🇽", "🇳🇱", "🇸🇪", "🇳🇴", "🇩🇰", "🇨🇭", "🇦🇹",
      "🇧🇪", "🇮🇪", "🇵🇹", "🇵🇱", "🇬🇷", "🇹🇷", "🇷🇺", "🇿🇦", "🇳🇬", "🇪🇬",
      "🇸🇦", "🇦🇪", "🇮🇱", "🇸🇬", "🇲🇾", "🇹🇭", "🇻🇳", "🇵🇭", "🇮🇩", "🇳🇿",
      "🇦🇷", "🇨🇱", "🇨🇴", "🇵🇪", "🇵🇰", "🇧🇩", "🇺🇦", "🇫🇮", "🇨🇿", "🇭🇺",
    ],
  },
  {
    id: "symbols",
    label: "Symbols",
    keywords: ["heart", "love", "music", "warning", "question"],
    emojis: [
      "❤️", "🧡", "💛", "💚", "💙", "💜", "🖤", "🤍", "💕", "💖",
      "⚡", "💎", "🎵", "🎶", "♻️", "⚠️", "❓", "❗", "✨", "💫",
    ],
  },
] as const;

export type EmojiCategory = (typeof EMOJI_CATEGORIES)[number];

export function getAllEmojis() {
  return EMOJI_CATEGORIES.flatMap((category) =>
    category.emojis.map((emoji) => ({
      emoji,
      categoryId: category.id,
      categoryLabel: category.label,
      keywords: category.keywords,
    })),
  );
}
